import React, { Component } from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { withRouter } from 'react-router-dom'

import PluginListHeader from "./PluginListHeader"
import PluginListItem from "./PluginListItem";
import PluginListTitle from "./PluginListTitle";
import PluginDetail from "./PluginDetail";
import {makeFilter, makeFilteredList, makeSearchKeyword} from "./PluginListHelper";

@connect(state => ({
	list: state.plugins.list,
}), dispatch => ({}))
@withRouter
class PluginList extends Component {

	constructor(props, context) {
		super(props, context)

		this.state = {
			selected: null,
			filter: makeFilter(props.location.pathname),
			searchKeyword: makeSearchKeyword(props.location.search)
		}
	}

	componentWillMount() {
		const { history } = this.props
		this.unlisten = history.listen(this.handleChangeLocation)
	}

	componentWillUnmount() {
		if (this.unlisten) {
			this.unlisten()
		}
	}

	@autobind
	handleChangeLocation(location) {
		this.setState({
			filter: makeFilter(location.pathname),
			searchKeyword: makeSearchKeyword(location.search)
		})
	}

	@autobind
	handleSelect(plugin) {
		this.setState({
			selected: plugin
		})
	}

	@autobind
	handleCloseDetail() {
		this.setState({
			selected: null
		})
	}

	render() {
		const { list } = this.props
		const { selected, searchKeyword, filter } = this.state

		let filteredList = makeFilteredList(list, searchKeyword, filter)

		return (
			<div>
				<div className="blog_plugin">

					<PluginListTitle searchKeyword={searchKeyword} filter={filter} count={filteredList.length} />

					<PluginListHeader filter={filter} />

					<strong className="screen_out">플러그인 목록</strong>

					{ filteredList.length === 0 &&
						<div className="info_none">
							<p className="txt_none">
								<span className="wrap_ico"><span className="ico_blog ico_search"/></span>
								검색 결과가 없습니다.
							</p>
						</div>
					}

					{ filteredList.length > 0 &&
						<ul className="list_plugin">
							{filteredList.map((plugin, index) =>
								<PluginListItem key={index} plugin={plugin} onSelect={this.handleSelect} />
							)}
						</ul>
					}

				</div>
				{ selected && <PluginDetail plugin={selected} onClose={this.handleCloseDetail} /> }
			</div>
		)
	}
}

export default PluginList
